import { ScaleLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import Layout from "../../../src/Layout/index";

const Loader = () => {
  const location = useLocation();

  // You can specify which paths you want to check
  const shouldShowLoader = location.pathname !== "/"; // Adjust this condition as needed

  return (
    shouldShowLoader && ( // Render the loader only if the condition is true
      <Layout>
        <div className="w-full h-screen flex justify-center items-center py-4 px-2">
          <ScaleLoader color="#6CCCF1" />
        </div>
      </Layout>
    )
  );
};

export default Loader;
